var _style, _g, _g2, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24DataEnTuComuna({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 345 110",
    style: {
      enableBackground: "new 0 0 345 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F81D28;}\n\t.st1{fill:#4A4C5A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,19.6c-1.7-0.6-3.6-0.1-4.7,1.3L87.7,49.2c-1.1,1.3-1.3,3-0.6,4.5c0.7,1.5,2.2,2.4,3.8,2.5l19.3,0v5 c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2v-4.9l2.7,0c0,0,0,0,0,0c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.3-4.2-4.3l-2.7,0 l0-24.1C118.8,21.8,117.7,20.2,116,19.6z M110.3,47.7l-10.3,0l10.3-12.3L110.3,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,57.6c-1.4,1.2-1.8,3-1.2,4.7c0.6,1.7,2.2,2.8,4,2.8c0,0,0,0,0,0L81.9,65c2.3,0,4.2-1.9,4.2-4.3 c0-2.3-1.9-4.2-4.2-4.2c0,0,0,0,0,0l-14,0.1c4.3-3.7,8.8-7.7,10.4-9.3c5.4-5.5,6.1-10.1,6.1-13.5c0-2.1-0.8-5.4-3-8.3 C79.5,23,76,20.1,70,19.8c-11.8-0.4-15.8,8.4-16,8.8l0,0c-0.2,0.5-0.3,1.1-0.3,1.7c0,2.4,1.9,4.3,4.3,4.3c1.8,0,3.3-1.1,3.9-2.7 c0.5-0.8,2.5-3.8,7.8-3.6c5.8,0.2,6.2,5.3,6.2,5.4c0,1.9-0.3,4.2-3.6,7.6C69.8,43.8,58,54,53.7,57.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91,77.7h-1.6l0,2.4H91c0.9,0,1.5-0.5,1.5-1.3C92.5,78.1,91.9,77.7,91,77.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 77.6,
    cy: 80.4,
    rx: 2.7,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.6,77.4c-0.1,0-0.1,0-0.1,0.2l-1,3.8h2.3l-1-3.8C103.7,77.5,103.7,77.4,103.6,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,69.8H57.5c-3,0-5.3,2.4-5.3,5.3v10.4c0,3,2.4,5.3,5.3,5.3h62.9c3,0,5.3-2.4,5.3-5.3V75.2 C125.7,72.2,123.3,69.8,120.4,69.8z M68.8,85.9h-3v-4h-4.3v4h-3V75h3v4.1h4.3V75h3V85.9z M77.6,86.1c-3.3,0-5.7-2.4-5.7-5.7 c0-3.2,2.5-5.7,5.7-5.7c3.3,0,5.7,2.4,5.7,5.7C83.4,83.7,80.9,86.1,77.6,86.1z M92.7,85.9l-1-2c-0.4-0.7-0.8-1-1.8-1h-0.5l0,3.1 h-3V75H91c2.6,0,4.5,1.2,4.5,3.6c0,1.4-0.8,2.6-2.1,3c0.5,0.4,0.9,1,1.4,2l1.1,2.3H92.7z M106,85.9l-0.5-1.8h-3.8l-0.5,1.8h-3 l2.8-9.2c0.4-1.3,1.5-2,2.7-2s2.3,0.6,2.7,2l2.8,9.2H106z M115.6,86.1c-2.1,0-3.7-0.9-4.4-2.5l2.5-1.2c0.3,0.7,0.9,1,1.9,1 c0.8,0,1.4-0.2,1.4-0.8c0-0.6-0.6-0.7-1.6-0.9c-1.6-0.2-4-0.9-4-3.5c0-2,1.8-3.5,4.2-3.5c1.9,0,3.5,0.9,4.3,2.5l-2.5,1.2 c-0.3-0.5-0.9-1-1.9-1c-0.7,0-1.1,0.2-1.1,0.7c0,0.6,0.7,0.8,1.8,1c1.6,0.2,3.9,0.9,3.9,3.5C120,84.6,118,86.1,115.6,86.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.5,67.6h-14.3V28.7h14.5c12.6,0,21,7.8,21,19.5C185.7,60.2,176.8,67.6,164.5,67.6z M164.7,36.5h-6.1v23.5 h5.9c7.3,0,12.5-4.6,12.5-11.9C177,41.2,172.1,36.5,164.7,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.6,34.2c1.3-4.2,4.8-6.2,8.4-6.2c3.7,0,7.2,2,8.5,6.2l10.3,33.4h-8.6l-2.3-8l-15.8,0.1l-2.3,7.9h-8.6 L199.6,34.2z M202.4,52.1h11.4l-4.4-15.4c-0.2-0.8-0.6-1.2-1.3-1.2c-0.6,0-1,0.3-1.3,1.2L202.4,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.7,36.5h-11.5v31.1h-8.4V36.5h-11.5v-7.8h31.4V36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,34.2c1.3-4.2,4.8-6.2,8.4-6.2c3.7,0,7.2,2,8.5,6.2l10.3,33.4h-8.6l-2.3-8l-15.8,0.1l-2.3,7.9h-8.6 L267.6,34.2z M270.3,52.1h11.4l-4.4-15.4c-0.2-0.8-0.6-1.2-1.3-1.2c-0.6,0-1,0.3-1.3,1.2L270.3,52.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.2,90.9L137.2,90.9c-0.8,0-1.5-0.7-1.5-1.5V21.1c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5v68.3 C138.7,90.2,138.1,90.9,137.2,90.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.6,77.6h-4.8v3.2h4.3v2h-4.3v3.4h4.8v2.1h-7.4V75.5h7.4V77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.5,75.5v12.7h-2.5l-5.8-8.7v8.7h-2.5V75.5h2.5l5.8,8.7v-8.7H171.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.1,75.5h9.3v2.1H185v10.6h-2.5V77.6h-3.4V75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.9,75.5h2.5v7.9c0,1.7,0.9,2.7,2.6,2.7c1.6,0,2.6-0.9,2.6-2.7v-7.9h2.6v7.8c0,3.3-2.4,5-5.2,5 s-5.1-1.6-5.1-5V75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.2,75.4c2.8,0,5.1,1.5,6,4.1h-2.9c-0.6-1.2-1.7-1.8-3.1-1.8c-2.2,0-3.8,1.6-3.8,4.2 c0,2.6,1.6,4.2,3.8,4.2c1.4,0,2.5-0.6,3.1-1.8h2.9c-0.9,2.6-3.1,4.1-6,4.1c-3.7,0-6.4-2.7-6.4-6.5C208.8,78,211.6,75.4,215.2,75.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230,88.3c-3.6,0-6.5-2.7-6.5-6.5c0-3.8,2.9-6.5,6.5-6.5c3.6,0,6.5,2.7,6.5,6.5 C236.5,85.6,233.6,88.3,230,88.3z M230,86.1c2.3,0,3.9-1.7,3.9-4.2c0-2.6-1.6-4.2-3.9-4.2c-2.3,0-3.9,1.6-3.9,4.2 C226.1,84.4,227.7,86.1,230,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,75.5h2.9l4,9.4l4-9.4h2.9v12.7h-2.5v-8.3l-3.4,8.3H245l-3.4-8.3v8.3h-2.5V75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.1,75.5h2.5v7.9c0,1.7,0.9,2.7,2.6,2.7c1.6,0,2.6-0.9,2.6-2.7v-7.9h2.6v7.8c0,3.3-2.4,5-5.2,5 s-5.1-1.6-5.1-5V75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.4,75.5v12.7h-2.5l-5.8-8.7v8.7h-2.5V75.5h2.5l5.8,8.7v-8.7H280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.4,85.8h-5.1l-0.8,2.4h-2.7l4.6-12.7h3l4.6,12.7h-2.7L291.4,85.8z M288.9,78.4l-1.8,5.3h3.7L288.9,78.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24DataEnTuComuna);
export default __webpack_public_path__ + "static/media/24-data-en-tu-comuna.eefa5c3818500345086d3c86b76ed489.svg";
export { ForwardRef as ReactComponent };